import { Dexiedb } from "./Dexiedb";
import { ContactRecord, IContact } from "./model/contact";
import { DBMessageDefault } from "./model/dbMessage";
import { DownloadAllContactGiaThuong } from "./repository/contactRepo";
export const globalDexieDb =   Dexiedb.getInstance()
export async function testDexie() {



    // let contact: IContact = new ContactRecord()
    // contact.contactId = 1
    // contact.name = "test1"
    // globalDexieDb.contacts.put(contact)

    // contact = new ContactRecord()
    // contact.contactId = 2
    // contact.name = "test2"
    // globalDexieDb.contacts.put(contact,)

    // contact = new ContactRecord()
    // contact.contactId = 3
    // contact.name = "test3"
    // globalDexieDb.contacts.put(contact)

    // const result = await globalDexieDb.contacts.toArray()
    // for (let i = 0; i < 1000; i++) {
    //     const msg = DBMessageDefault()
    //     globalDexieDb.dbmessages.put(msg)
    // }
    DownloadAllContactGiaThuong()
    // return result;
}